import { Link } from 'react-router-dom'
import { FileText } from 'lucide-react'

/** The quotation raised for a deal (set by the API on every deal it returns). */
export interface DealQuotationRef {
  id: string
  number: string
  status: string
}

/** Opens the quotation on the Quotations page. */
export const quotationViewPath = (quotation: { id: string }) => `/app/sales/quotations?view=${quotation.id}`

/**
 * Shown in place of "Create Quotation" once the deal has a quotation: a deal gets one quotation,
 * which is then viewed, edited or revised, not created again.
 */
export function DealQuotationLink({
  quotation,
  className = '',
  iconClassName = 'h-3.5 w-3.5',
}: {
  quotation: DealQuotationRef
  className?: string
  iconClassName?: string
}) {
  return (
    <Link
      to={quotationViewPath(quotation)}
      onClick={(e) => e.stopPropagation()}
      title={`View quotation ${quotation.number}`}
      className={`inline-flex items-center justify-center gap-1.5 rounded-md border border-emerald-500/40 bg-emerald-50/60 text-xs font-semibold text-emerald-700 shadow-2xs transition-colors hover:bg-emerald-100 dark:bg-emerald-950/30 dark:text-emerald-300 dark:hover:bg-emerald-950/50 ${className}`}
    >
      <FileText className={`${iconClassName} text-emerald-600 dark:text-emerald-400`} />
      <span>View Quotation</span>
      {quotation.number && <span className="font-mono text-[10px] font-normal opacity-70">{quotation.number}</span>}
    </Link>
  )
}
